import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Layout, Menu, Typography, Badge } from 'antd';
import type { MenuProps } from 'antd';
import {
  DashboardOutlined,
  ShopOutlined,
  TeamOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  FileTextOutlined,
  ContactsOutlined,
  HomeOutlined,
  BankOutlined
} from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import AdminHeader from './AdminHeader';

const { Sider, Content } = Layout;
const { Title } = Typography;

type MenuItem = Required<MenuProps>['items'][number];

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut, session } = useAuth();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const menuItems: MenuItem[] = [
    {
      key: '/admin',
      icon: <DashboardOutlined />,
      label: <Link to="/admin">Dashboard</Link>,
    },
    {
      key: '/admin/products',
      icon: <ShopOutlined />,
      label: <Link to="/admin/products">Producten</Link>,
    },
    {
      key: '/admin/companies',
      icon: <TeamOutlined />,
      label: <Link to="/admin/companies">Klanten</Link>,
    },
    {
      key: '/admin/orders',
      icon: <FileTextOutlined />,
      label: <Link to="/admin/orders">Bestellingen</Link>,
    },
    {
      key: '/admin/leveranciers',
      icon: <ContactsOutlined />,
      label: <Link to="/admin/leveranciers">Leveranciers</Link>,
    },
    {
      key: '/admin/settings',
      icon: <SettingOutlined />,
      label: <Link to="/admin/settings">Instellingen</Link>,
    },
    {
      key: 'divider',
      type: 'divider',
    },
    {
      key: 'client-section',
      type: 'group',
      label: 'Klant Weergave',
    },
    {
      key: '/dashboard',
      icon: <HomeOutlined />,
      label: <Link to="/dashboard">Klant Dashboard</Link>,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 999,
        }}
        width={240}
      >
        <div style={{ 
          height: 64, 
          margin: '16px 0',
          paddingLeft: collapsed ? 24 : 24,
          display: 'flex',
          alignItems: 'center',
        }}>
          <Title level={4} style={{ color: 'white', margin: 0, whiteSpace: 'nowrap' }}>
            {collapsed ? 'RP' : 'RE-PACKED Admin'}
          </Title>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          defaultOpenKeys={['products-submenu', 'orders-submenu']}
          items={menuItems}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <Layout style={{ marginLeft: collapsed ? 80 : 240, transition: 'margin-left 0.2s' }}>
        <AdminHeader collapsed={collapsed} toggle={toggleCollapsed} />
        <Content style={{ minHeight: 'calc(100vh - 64px)' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
} 